import React from 'react';
import { makerVariant } from '../variant-resolver.tsx';
function HeroSection() {
  return <div className="relative h-screen flex items-center justify-center text-center text-white">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://aicdn.maker.co/generated-images/user_2ZAtAYc1MFcL5x3zo53g47MXUVS/cmciwvv1c009khs5rmi45dmla/7cc33eec-b537-4930-be9b-12698680a31d/13fcc36d04f15ceb00867f97bc1e8296.jpeg')`
    }}>
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Transform Your
          <span className={`block ${makerVariant('accentTextColor', 'text-green-400')}`}>Digital Future</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
          We create cutting-edge solutions that drive innovation and deliver exceptional results for businesses worldwide.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-green-600 hover:bg-green-700 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200" data-tracking-id="btn-394cdb92cd95f398">
            Get Started
          </button>
          <button className="border-2 border-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200" data-tracking-id="btn-fb2cca6131f9adb8">
            Learn More
          </button>
        </div>
      </div>
      
      {/* Image Attribution */}
      <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
        <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
        <span className="hidden drop-shadow-md group-hover/attribution:block">
          Image on{' '}
          <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
          color: '#fff',
          textDecoration: 'none'
        }} data-tracking-id="link-509696255789abc2">
            Unsplash
          </a>{' '}
          by{' '}
          <a href="https://unsplash.com/@xingchenyan?utm_source=makerdevi&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
          color: '#fff',
          textDecoration: 'none'
        }} data-tracking-id="link-4491e764a4af794d">
            Xingchen Yan
          </a>
        </span>
      </span>
    </div>;
}
export default HeroSection;